import request from './request.js';
import {requestbody} from './request.js'
// 进项发票文件上传
export async function dkdj_importExcel (params = {

}) {
return await request('dkdj/file/upload', 'post', params)
}
// 查询进行发票合计结果(分页)
export async function dkdj_fetchResultShow(params = {

}) {
return await requestbody('dkdj/list/query', 'post', params)
}
// 导出进项发票合计结果
export async function dkdj_outPutResult(params = {

}) {
return await requestbody('dkdj/outPutResult', 'post', params)
}

// 查询票据明细记录
export async function dkdj_fetchBillDetails(params = {

}){
return await requestbody('dkdj/detail/query', 'post', params)
}
// 删除
export async function dkdj_delete(params = {

}){
return await requestbody('dkdj/result/delete', 'post', params)
}